<template>
	<v-dialog scrollable v-model="dialog.display" max-width="90%">
		<v-card>
			<v-layout wrap>
				<v-toolbar xs12 flat dark color="primary" height="40px" class="d-flex" style="position: relative;">
					<v-btn flat dark class="btn-today ma-0 pa-0" @click="onClickMoveToday">
						今月
					</v-btn>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn flat class="mr-1" @click="$refs.calendar.prev()">
							<v-icon dark>keyboard_arrow_left</v-icon>
							前月
						</v-btn>
						<v-menu
							ref="tc_month_calendar"
							v-model="tc_month_calendar"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
							<template v-slot:activator="{ on }">
								<v-btn flat class="pa-0 ma-0 year-month" v-on="on">
									{{ showYearMonth }}
								</v-btn>
							</template>
							<v-date-picker
								v-model="month"
								no-title
								@input="onSelectMonth"
								locale="jp-ja"
								type="month"
							></v-date-picker>
						</v-menu>
						<v-btn flat class="ml-1" @click="$refs.calendar.next()">
							翌月
							<v-icon dark>keyboard_arrow_right</v-icon>
						</v-btn>
					</v-toolbar-items>
					<v-spacer></v-spacer>
					<v-btn flat dark class="btn-close ma-0 pa-0" @click="onClose">
						<v-icon>clear</v-icon>
					</v-btn>
				</v-toolbar>
				<v-flex>
					<v-sheet :height="styleHeightCalendar" class="dialog-calendar-content-wrap">
						<v-calendar
							ref="calendar"
							:now="today"
							:value="today"
							color="primary"
							v-model="start"
							@click:date="onSelectDate"
							class="dialog-calendar-content"
						>
							<template v-slot:day="{ date }">
								<template v-for="(event, index) in eventsMap[date]">
									<v-menu
										:key="event.code"
										v-model="event.open"
										full-width
										offset-x
										v-if="index < 3 && !(index == 2 && eventsMap[date].length > 3)"
									>
										<template v-slot:activator="{ on }">
											<div
												v-ripple
												class="event"
												:class="event.project_name ? 'project-task' : 'task'"
												v-on="on"
											>
												<span class="pr-1">{{ event.time_schedule_text }}</span>
												<span>{{event.name }}</span>
											</div>
										</template>
										<v-card
											color="grey lighten-4"
											width="350px"
											flat
										>
											<v-toolbar color="primary" dark>
												<v-toolbar-title v-html="event.name"></v-toolbar-title>
												<v-spacer></v-spacer>
												<v-btn icon>
													<v-icon>close</v-icon>
												</v-btn>
											</v-toolbar>
											<v-card-title primary-title class="d-block">
												<v-layout wrap ma-2 pr-2>
													<v-flex xs2>期間</v-flex>
													<v-flex xs10>{{ event.schedule_text }}</v-flex>
												</v-layout>
												<v-layout wrap mt-3 mb-3 mx-2 pr-2>
													<v-flex xs2>案件</v-flex>
													<v-flex xs10>{{ event.project_name }}</v-flex>
												</v-layout>
												<v-layout wrap mt-3 mb-3 mx-2 pr-2>
													<v-flex xs2>備考</v-flex>
													<v-flex xs10>{{ event.remarks }}</v-flex>
												</v-layout>
											</v-card-title>
										</v-card>
									</v-menu>
									<div
										:key="event.code"
										v-if="index >= 3  && index == eventsMap[date].length - 1"
										class="other-cases"
									>
										他{{ index - 1 }}件
									</div>
								</template>
							</template>
						</v-calendar>
					</v-sheet>
				</v-flex>
			</v-layout>
		</v-card>
	</v-dialog>
</template>
<script>
import { strftime, LOGIN_USER_CODE } from '../../classes/Const';
import ScheduleTick from '../../classes/ScheduleTick';
import Member from '../../classes/Member';
import Task from '../../classes/Task';
import Schedule from '../../classes/Schedule';

const DISPLAY_TIME_TYPE = {
	BEGIN: 0,
	END: 1,
	ALL_DAY: 2,
}

export default {
	name: 'TCDialogCalendar',
	props: ['dialog'],
	data() {
		return {
			today: strftime('%Y-%m-%d', new Date()),
			start: strftime('%Y-%m-%d', this.$store.getters.currentDate),
			tc_month_calendar: false,
			month: strftime('%Y-%m', this.$store.getters.currentDate),
		}
	},
	methods: {
		open (event) {
			alert(event.title)
		},
		onClose: function() {
			this.$emit('close');
		},
		onSelectDate: function(e) {
			this.$store.dispatch('setCurrentDate', new Date(e.date.replace(/-/g, '/')));
			this.onClose();
		},
		onClickMoveToday: function() {
			this.start = strftime('%Y-%m-%d', new Date());
		},
		onSelectMonth: function(e) {
			this.tc_month_calendar = false;
			this.start = strftime('%Y-%m-%d', new Date(this.month.replace(/-/g, '/') + '/01'));
		},
	},
	computed: {
		display: function() {
			return this.dialog.display;
		},
		displayList: function () {
			let display_tasks = new Array();
			this.$store.getters.dataTask.forEach( t => {
				if (t.member_code === LOGIN_USER_CODE) {
					let display_schedueles = new Array();
					t.schedules.forEach( s => {
						if (s.isContainsMonth(new Date(this.start.replace(/-/g, '/'))))
							if (s.isSingleDay) {
								s.original = s;
								s.display_time_type = DISPLAY_TIME_TYPE.BEGIN;
								if (s.all_day)
									s.display_time_type = DISPLAY_TIME_TYPE.ALL_DAY;
								display_schedueles.push(s);
							} else {
								let term = s.scheduleDayTerm();
								for (let i = 0; i < term; i++) {
									let begin = null;
									let end = null;
									let display_time_type = DISPLAY_TIME_TYPE.BEGIN;
									let all_day = false;
									
									if (i === 0) {
										begin = s.begin.clone();
										let d = s.begin.asDateYmd;
										d.setHours(d.getHours() + 24);
										end = ScheduleTick.createTickFromDate(d);
										
										let next_day = new Date(s.begin.asDate.getTime());
										next_day.setDate(next_day.getDate() + 1);
										if (s.begin.isFirstTick(s.begin.asDate) && s.end.isFirstTick(next_day)) {
											display_time_type = DISPLAY_TIME_TYPE.ALL_DAY;
											all_day = true;
										} else {
											display_time_type = DISPLAY_TIME_TYPE.BEGIN;
										}
										
									} else if (i === term - 1) {
										if (!s.end.isFirstTick(s.end.asDate)) {
											begin = ScheduleTick.createTickFromDate(s.end.asDateYmd);
											end = s.end.clone();
											display_time_type = DISPLAY_TIME_TYPE.END;
										} else {
											let d = s.end.asDateYmd;
											d.setDate(d.getDate() - 1);
											begin = ScheduleTick.createTickFromDate(d);
											d.setHours(24);
											end = ScheduleTick.createTickFromDate(d);
											display_time_type = DISPLAY_TIME_TYPE.ALL_DAY;
											all_day = true;
										}
										
									} else {
										let begin_date = s.begin.asDateYmd;
										begin_date.setDate(begin_date.getDate() + i);
										begin = ScheduleTick.createTickFromDate(begin_date);
										
										let end_date = s.begin.asDateYmd;
										end_date.setDate(end_date.getDate() + i);
										end_date.setHours(end_date.getDate() + 24);
										end =  ScheduleTick.createTickFromDate(end_date);
										
										all_day = true;
										display_time_type = DISPLAY_TIME_TYPE.ALL_DAY;
									}
									
									if (s.all_day) {
										display_time_type = DISPLAY_TIME_TYPE.ALL_DAY;
										all_day = true;
									}
									
									let one_day_schedule = new Schedule({
										code: s.code,
										project_code: s.project_code,
										member_code: s.member_code,
										task_code: s.task_code,
										all_day: all_day,
										begin: begin, 
										end: end,
									});
									one_day_schedule.original = s;
									one_day_schedule.display_time_type = display_time_type;
								
									display_schedueles.push(one_day_schedule);
								}
							}
					});
					if (display_schedueles.length > 0) {
						display_tasks.push(new Task({
							code: t.code,
							name: t.name,
							schedules: display_schedueles,
							project_code: t.project_code,
							member_code: t.member_code,
							remarks: t.remarks,
						}));
					}
				}
			});
			if (display_tasks.length == 0)
				return display_tasks;
			
			let schedules = [];
			display_tasks.forEach(t => {
				t.schedules.forEach(s => {
					if (this.$store.getters['chart/isDisplayMemberList'])
						schedules.push(s);
					else if (!this.$store.getters['chart/isDisplayMemberList'] && s.project_code)
						schedules.push(s);
				});
			});
			
			return new Member(Object.assign(Object.assign({}, this.$store.getters.member(LOGIN_USER_CODE)), {
				children: display_tasks,
				schedules: schedules,
			}));
		},
		events: function() {
			if (!this.displayList.schedules)
				return null;
		
			return this.displayList.schedules.map(s => {
				let task_info = this.$store.getters.task(s.task_code);
				
				let schedule_text = "";
				let time_schedule_text = "";
				
				if (s.original.all_day) {
					schedule_text = s.original.begin.strftimeDCL('%m月%d日') + "～" + s.original.end.strftimeDCL('%m月%d日');
				} else {
					if (s.original.isSingleDay) {
						schedule_text = s.original.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + s.original.end.strftimeDCL('%H:%M');
					} else {
						schedule_text = s.original.begin.strftimeDCL('%m月%d日 %H:%M') + "～" + s.original.end.strftimeDCL('%H:%M %m月%d日');
					}
				}
				
				switch(s.display_time_type) {
					case DISPLAY_TIME_TYPE.BEGIN: 	time_schedule_text = s.begin.strftime('%H:%M') + ' -';	break;
					case DISPLAY_TIME_TYPE.END: 	time_schedule_text = '- ' + s.end.strftime('%H:%M');	break;
					case DISPLAY_TIME_TYPE.ALL_DAY:	time_schedule_text = '終日';								break;
				}
				
				return {
					code: s.code,
					name: task_info.name,
					remarks: task_info.remarks,
					date: s.begin.strftime('%Y-%m-%d'),
					begin: s.original.begin,
					all_day: s.all_day,
					time_schedule_text: time_schedule_text,
					schedule_text: schedule_text,
					project_name: s.project_code ? this.$store.getters.project(s.project_code).name : '',
					open: false,
				}
			});
		},
		eventsMap () {
			if (!this.display)
				return [];
			if (!this.events)
				return [];
			
			const map = {}
			this.events.forEach(e => {(map[e.date] = map[e.date] || []).push(e)});
			
			Object.keys(map).forEach(key => {
				map[key].sort((a, b) => {
					if (a.all_day && b.all_day) {
						if (a.begin.isBeforeDay(b.begin.asDate)) return -1;
						if (a.begin.isAfterDay(b.begin.asDate)) return 1;
						if (a.begin.getDiffFromDateAsMinutes(b.begin.asDate) < 0) return -1;
						if (a.begin.getDiffFromDateAsMinutes(b.begin.asDate) > 0) return 1;
						return 0;
					} else if (a.all_day && !b.all_day) {
						return -1;
					} else if (!a.alert && b.all_day) {
						return 1;
					} else {
						if (a.begin.getDiffFromDateAsMinutes(b.begin.asDate) < 0) return -1;
						if (a.begin.getDiffFromDateAsMinutes(b.begin.asDate) > 0) return 1;
						return 0;
					}
				});
			});
			
			return map
		},
		showYearMonth: function() {
			return strftime('%Y年%m月', new Date(this.start.replace(/-/g, '/')));
		},
		styleHeightCalendar: function() {
			let height = this.$store.getters.windowHeight - 150;
			if (height > 611)
				height = 611;
			return height;
		},
	},
	watch: {
		display: function() {
			if (this.display)
				this.start = strftime('%Y-%m-%d', this.$store.getters.currentDate);
		},
		start: function() {
			this.month = strftime('%Y-%m', new Date(this.start.replace(/-/g, '/')));
		},
	},
}
</script>
<style>
.dialog-calendar-content-wrap {
	overflow-y: hidden;
	overflow-x: hidden;
}
.dialog-calendar-content {
	overflow-y: scroll;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior-y: contain;
}
</style>
<style scoped>
.event {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	border-radius: 2px;
	color: #ffffff;
	width: 100%;
	font-size: 12px;
	padding: 3px;
	cursor: pointer;
	margin-bottom: 1px;
}
.project-task.event {
	background-color: green;
	border: 1px solid green;
	opacity: .5;
}
.task.event {
	background-color: #00f;
	border: 1px solid #00f;
	opacity: .5;
}
.year-month {
	position: relative;
	font-size: 20px;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 110px;
	margin: 0px 40px;
}
.btn-today, .btn-close {
	min-width: 40px;
}
.other-cases {
	text-align: right;
}
</style>
